module.exports = "/images/vendor/flag-icon-css/flags/1x1/ky.svg?ef1f65378cdaea3bc6a0dddfeb9d0de9";